import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Link } from "react-router-dom";
import { ShieldCheck, Sparkles, Heart, Award } from "lucide-react";

export default function ChiSiamo() {
  return (
    <main data-testid="chi-siamo-page" className="min-h-screen bg-white">
      <Header />

      <section className="pt-32 pb-20 max-w-5xl mx-auto px-6 md:px-10">
        <div className="text-[11px] uppercase tracking-[0.3em] text-[#5ab500] font-bold mb-4">
          — Chi Siamo
        </div>
        <h1 className="font-heading text-5xl md:text-7xl font-light tracking-tight text-[#1c1f1a] leading-[1.05]">
          La <span className="italic text-[#5ab500]">storia</span> dietro
          Minicarmobilità.
        </h1>

        <div className="mt-12 prose max-w-none">
          <p className="text-[#1c1f1a] text-lg leading-relaxed">
            Minicarmobilità nasce a Zibido San Giacomo da una passione: rendere
            la mobilità urbana più semplice, più sicura e più sostenibile. La
            nostra vetrina è giovane ma il nostro team ha anni di esperienza nel
            mondo automotive e two-wheels. Ai nostri clienti offriamo anche{" "}
            <strong>consegna a domicilio</strong> (Cell. 329 745 2439) e un{" "}
            <strong>servizio di assistenza tecnica anche a domicilio</strong>{" "}
            — scrivici dalla{" "}
            <Link to="/contatti" className="text-[#5ab500] underline-offset-2 hover:underline">
              pagina contatti
            </Link>{" "}
            per maggiori informazioni.
          </p>

          <p className="text-[#4a4f47] mt-6 leading-relaxed">
            Crediamo che oggi muoversi in città richieda nuove risposte. Per
            questo abbiamo scelto di unire sotto un unico tetto due mondi
            complementari: gli{" "}
            <strong className="text-[#1c1f1a]">scooter cabinati</strong>, la
            rivoluzione silenziosa della mobilità leggera, e una selezione
            curata di <strong className="text-[#1c1f1a]">auto usate</strong> di
            qualità.
          </p>

          <h2 className="font-heading text-3xl text-[#1c1f1a] mt-12 mb-4">
            Gli scooter cabinati: il futuro è già qui
          </h2>
          <p className="text-[#4a4f47] leading-relaxed">
            Immagina la libertà di uno scooter — niente traffico, parcheggio
            facile, consumi minimi — unita al comfort di un'auto: protezione da
            pioggia e vento, abitacolo chiuso, stabilità. Lo scooter cabinato è
            esattamente questo. Un mezzo che sta conquistando le città italiane
            perché risponde a un bisogno reale: muoversi tutti i giorni in modo
            intelligente.
          </p>

          <h2 className="font-heading text-3xl text-[#1c1f1a] mt-12 mb-4">
            L'usato che non ti tradisce
          </h2>
          <p className="text-[#4a4f47] leading-relaxed">
            Ogni auto usata che entra nella nostra vetrina viene controllata,
            tagliandata e venduta con garanzia. Niente sorprese, niente
            documenti dubbi, niente prezzi gonfiati. Solo veicoli pronti a
            partire con te, scelti con la stessa cura con cui sceglieremmo
            l'auto per la nostra famiglia.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-5">
          {[
            { icon: ShieldCheck, t: "Garanzia inclusa", d: "Tagliandi certificati su tutti i veicoli." },
            { icon: Sparkles, t: "Selezione rigorosa", d: "Solo veicoli che acquisteremmo noi stessi." },
            { icon: Heart, t: "Persone, non solo veicoli", d: "Ti accompagniamo prima, durante e dopo l'acquisto." },
            { icon: Award, t: "Trasparenza totale", d: "Storia, prezzo, condizioni: tutto sul tavolo." },
          ].map(({ icon: Icon, t, d }) => (
            <div
              key={t}
              className="bg-[#f5f6f4] rounded-2xl p-6 border border-black/[0.04] hover:border-[#5ab500]/40 transition"
            >
              <div className="w-11 h-11 rounded-lg bg-[#5ab500]/10 flex items-center justify-center mb-3">
                <Icon className="text-[#5ab500]" size={20} />
              </div>
              <div className="text-[#1c1f1a] font-bold mb-1">{t}</div>
              <div className="text-sm text-[#4a4f47]">{d}</div>
            </div>
          ))}
        </div>

        <div className="mt-16 flex flex-wrap gap-4">
          <Link
            to="/veicoli"
            data-testid="chisiamo-vetrina-cta"
            className="px-7 py-3.5 rounded-full bg-[#5ab500] text-white font-bold hover:bg-[#4a9a00] hover:shadow-[0_8px_24px_rgba(90,181,0,0.4)] transition-all"
          >
            Esplora la vetrina
          </Link>
          <Link
            to="/contatti"
            data-testid="chisiamo-contatti-cta"
            className="px-7 py-3.5 rounded-full border border-[#1c1f1a]/20 text-[#1c1f1a] font-semibold hover:border-[#1c1f1a] hover:bg-[#1c1f1a] hover:text-white transition-all"
          >
            Contattaci
          </Link>
        </div>
      </section>

      <Footer />
    </main>
  );
}
